import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

export const searchCustomer = async (mobileCountryCode, mobileNo) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.CUSTOMER_SEARCH, {
      mobile_country_code: mobileCountryCode,
      mobile_no: mobileNo,
    });

    if(response.data.data){
      return response.data.data[0];
    }else{
      return null;
    }
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
